import { ConceptStatusValidity, ConceptStatusValuePrimitive } from "@fusion-advantage/backcompat"
import { ConceptActivation } from "../../concept/ConceptActivation"
import { ConceptStatusUpdate } from "../../concept/ConceptStatusUpdate"
import { CalcType } from "../scriptcompiler/CompilerTypes"
import { ASTNode } from "../scriptcompiler/AstNode"

// the types that an expression, when evaluated, can yield
// LET xs = "lorem ipsum"
// LET xn = 1
// LET xb = TRUE
// LET xx = NULL
// LET xa = [1,2,3,4,5]
// BUT NOT
// LET xaa = [[1,2],[3,4]]
// because we don't support multi-dimensional arrays
export type CalcRuntimeExprScalarValue = ConceptStatusValuePrimitive
export type CalcRuntimeExprArrayValue = ConceptStatusValuePrimitive[]
export type CalcRuntimeExprValue = CalcRuntimeExprScalarValue|CalcRuntimeExprArrayValue

export type ValueCalcRuntimeReturnValueItem = Pick<ConceptStatusUpdate, 'subconceptCid'|'value'>

export type CalcRuntimeReturnValueEnvelope = {
	calcType: typeof CalcType.Value
	// this is empty if unchanged
	returnValue: ValueCalcRuntimeReturnValueItem[]
} | {
	calcType: typeof CalcType.Validation
	returnValue: ConceptStatusValidity
} | {
	calcType: typeof CalcType.Activation
	returnValue: ConceptActivation
}

export interface CalcRuntimePrintEntry {
	message: string
	line: number
	column: number
}

export type CompiledCalcEvaluateOk = CalcRuntimeReturnValueEnvelope & {
	returnNode?: ASTNode  // available with script calcs, not hardcodes
	printed?: CalcRuntimePrintEntry[]  // ditto
}

export interface CalcRuntimeError {
	area: string
	message: string
	line?: number
	column?: number
}

export const CalcScriptRuntimeErrorMsgs = {
	ReturnStatementInferredChangedCalcType: (compileInferred: CalcType, evalInferred: CalcType) => 
		`Evaluated RETURN statement inferred calculation type '${evalInferred}', but type '${compileInferred}' was previously inferred by compiler`,
} as const
